import { useMemo } from 'react';
import { useAuthContext } from 'src/auth/useAuthContext';
import type { UserAllRecents, UserRecent } from './types';
import { useRecentsMessages } from './useRecentsMessages';
import { useRecentStore } from './useRecentsPersistence';

export const useUserRecents = (): UserAllRecents => {
  const { user } = useAuthContext();
  const { recentsMessages } = useRecentsMessages();
  const { recents } = useRecentStore((state) => ({
    recents: state.recents[user?.workspace?._id || '']?.[user?._id || ''],
    fetch: state.fetch,
  }));

  const allRecents = useMemo(
    () => [
      ...(recentsMessages || []),
      ...(recents || []).filter(
        (r) => !recentsMessages?.find((rm) => rm._id === r.objectRef),
      ),
    ],
    [recents, recentsMessages],
  ) as UserRecent[];

  return {
    recents: [...allRecents].slice(0, 5),
    allRecents,
  };
};
